export enum Filter {
    WEEK = "Week",
    MONTH = "Month",
    YEAR = "Year",
    PGRMSTART = "All",
}

export enum HealthInputName {
    Weight = "Weight",
    BodyComposition = "Body Composition",
    Exercise = "Exercise",
    BloodPressure = "Blood Pressure",
    TobaccoCount = "Tobacco Count",
    BloodSugar = "Blood Sugar",
    Hba1c = "HbA1c",
    ElectroDermalActivity = "Electrodermal Activity",
}

export interface AbstractHealthInput {
    id: string;
    at: Date;
    updatedAt: Date;
    createdAt: Date;
    exerciseMinutes: string;
    steps: string;
    sync_type: string;
    preferrd_weight_unit?: string;
}

export type ChartDataRow = (
    | Date
    | number
    | string
    | null
    | { label: string | null; role: string; type?: string }
)[];
export type ChartData = ChartDataRow[];

export interface DropDownInterface {
    label: string;
    value: string;
}
